//this component is used to wrap all authenticated routes and handle token refresh and idle logout
import { Outlet } from "react-router-dom";
import useIdleLogout from "../../hooks/useIdleLogout";
import useTokenRefresh from "../../hooks/useTokenRefresh";

const AuthenticatedLayout = () => {
  useIdleLogout(60); // 1 hour idle time
  useTokenRefresh(); // Refresh token 10 minutes before expiration

  return <Outlet />;
};

export default AuthenticatedLayout;